import { TypedUseSelectorHook, useSelector } from 'react-redux';

export type DefaultReducersReduxState = {
    relayVariables: {
        variables: {
            showLoading?: boolean;
            userId?: string;
            itemId?: string;
            isClient: boolean;
            isMultiSku?: boolean;
            fetchAuction?: boolean;
            fetchUser?: boolean;
            isTrade?: boolean;
            priceBookName: string;
            updateAuctionItem?: boolean;
            updatedUserCountryCode?: string;
            updateItemPricing?: boolean;
            shouldFetchSponsoredItems?: boolean;
            includeSponsoredItems?: boolean;
        };
    };
    header: {
        updateUserState?: boolean;
    };
};

export const useSbSelector: TypedUseSelectorHook<DefaultReducersReduxState> = useSelector;
